import {AxiosService} from "./axiosService";

export class WeatherStationService extends AxiosService {
    async getWeatherStations(pageSize, pageIndex, sortField, sortDirection) {
        try {
            const { data } = await this.axios.get('/weather-stations', {
                params: {
                    pageSize: pageSize,
                    pageIndex: pageIndex,
                    sortBy: sortField,
                    orderBy: sortDirection
                },
            });
            return data;
        } catch (e) {
            // if the status code is a 401 we do NOT want to throw
            if (e?.response?.status !== 401) {
                throw e;
            }
        }
        return null;
    }
    
    async postWeatherStation(name, usaf, wban, icao) {
        try {
            const { data } = await this.axios.post('/weather-stations', {
                name,
                usaf,
                wban,
                icao
            });
            return data;
        } catch (e) {
            // if the status code is a 401 we do NOT want to throw
            if (e?.response?.status !== 401) {
                throw e;
            }
        }
        return null;
    }
    
    async getWeatherStationById(weatherStationId) {
        try {
            const { data } = await this.axios.get(`/weather-stations/${weatherStationId}`);
            return data.data;
        } catch (e) {
            // if the status code is a 401 we do NOT want to throw
            if (e?.response?.status !== 401) {
                throw e;
            }
        }
        return null;
    }
    
    async editWeatherStation(id, name, usaf, wban, icao) {
        try {
            const { data } = await this.axios.put('/weather-stations', {
                id,
                name,
                usaf,
                wban,
                icao
            });
            return data;
        } catch (e) {
            // if the status code is a 401 we do NOT want to throw
            if (e?.response?.status !== 401) {
                throw e;
            }
        }
        return null;
    }
    
    async deleteWeatherStation(weatherStationId) {
        try {
            const { data } = await this.axios.delete(`/weather-stations/${weatherStationId}`);
            return data;
        } catch (e) {
            // if the status code is a 401 we do NOT want to throw
            if (e?.response?.status !== 401) {
                throw e;
            }
        }
        return null;
    }
}

export const weatherStationService = new WeatherStationService();
